import { useAppSelector } from "./useStoreHooks";
import { useMobileType } from "./useMobileType";
import { useDesktopType } from "./useDesktopType";
import { useTabletType } from "./useTabletType";

export interface ResponsiveLayoutProps {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
}

export const useResponsiveLayout = () => {
  const userDevice = useAppSelector((state) => state.user.userDevice);
  const isMobileViewport = useMobileType();
  const isDesktopViewport = useDesktopType();
  const isTabletOrDesktopViewport = useTabletType();
  const isTabletViewport = isTabletOrDesktopViewport && !isDesktopViewport;

  // DevTools set userDevice to "smartphone", so check both userDevice and viewport
  const isDesktopViewportOnDesktopViaDevTools =
    isDesktopViewport && userDevice === "smartphone";
  const isTabletViewportOnDesktop =
    isTabletViewport && (userDevice === "desktop" || userDevice === "smartphone");
  const isMobileViewportOnDesktop = isMobileViewport && userDevice === "desktop";

  const isDesktop =
    (userDevice === "desktop" && isDesktopViewport) ||
    isDesktopViewportOnDesktopViaDevTools;
  const isTablet = userDevice === "tablet" || isTabletViewportOnDesktop;
  const isMobile =
    (userDevice === "smartphone" && !isDesktop && !isTablet) ||
    isMobileViewportOnDesktop;

  return { isMobile, isTablet, isDesktop };
};
